<template>
  <div class="fz-sidebar__search">
    <SearchByVin />
    <SearchByParts />
  </div>
</template>
<script>
import { sidebar } from '@/modules/core';
import SearchByVin from '../search/SearchByVin.vue';
import SearchByParts from '../search/SearchByParts.vue';

export default {
  name: 'SearchSidebarContent',
  mixins: [sidebar],
  components: {
    SearchByVin,
    SearchByParts,
  },
};
</script>
<style lang="scss" scoped>
</style>
